import Vue from "vue";
import App from "./App.vue";
import store from "./store/index";
import router from "./router/index";
import "@/assets/css/public.less";
import YDUI from "vue-ydui";
import "vue-ydui/dist/ydui.rem.css";

import Confirm from "@/components/Confirm/index.js";
import loading from "@/components/loading/index.js";
// import Poster from "@/components/Poster/post.js";
// import FastClick from "fastclick";
import { postRequest } from "../src/assets/utils/api";
import VueClipboard from "vue-clipboard2";
import VueLazyload from "vue-lazyload";
import { Phone } from "@/components/Phone/Phone.js";
Vue.use(VueLazyload);
Vue.use(YDUI);
VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);
Vue.config.productionTip = false;
Vue.prototype.postRequest = postRequest;
Vue.prototype.$bindPhone = Phone;
Vue.prototype.$confirm = Confirm;
Vue.prototype.$loading = loading;
// Vue.prototype.$poster = Poster;
// import VConsole from "vconsole/dist/vconsole.min.js"; //import vconsole
// let vConsole = new VConsole(); // 初始化
Vue.filter("specialTime", function(timestamp, type) {
  if (!timestamp) return "";
  var date = new Date(timestamp * 1000);
  //获取当前年份;
  var Y = date.getFullYear();
  var newY = new Date().getFullYear();

  if (newY == Y) {
    Y = "";
  } else {
    Y = Y + "-";
  }
  var M = date.getMonth() + 1;
  var D = date.getDate();
  var h = date.getHours();
  var m = date.getMinutes();
  if (type == "YMD") {
    return Y + add0(M) + "-" + add0(D);
  }
  if (type == "YMDSM") {
    return (
      date.getFullYear() +
      "-" +
      add0(M) +
      "-" +
      add0(D) +
      " " +
      add0(h) +
      ":" +
      add0(m)
    );
  }
  return Y + add0(M) + "-" + add0(D) + " " + add0(h) + ":" + add0(m);
});
function add0(m) {
  return m < 10 ? "0" + m : m;
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
